module.exports = __webpack_public_path__ + "static/media/calendar.00570dd1.svg";